import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IntroStateService {
  constructor() {}

  activeState$ = new BehaviorSubject(true);

  activate() {
    this.activeState$.next(true);
  }
  deactivate() {
    this.activeState$.next(false);
  }
}
